import { Grid, Button, TextField, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { createCrsUpdate, parseBill } from '../../api/bill';
import { Alert } from '../Alert/Alert';
import ReactJson from 'react-json-view';
import { useDispatch } from 'react-redux';
import { UiActionType } from '../../reducers/ui.reducer';

const useStyles = makeStyles(_ => ({
    root: {
        maxWidth: '80%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 20
    },
}));

const BillParserPage : React.FC = () => {
    const classes = useStyles();
    const [value, setValue] = useState<string>("");
    const [error, setError] = useState<string>("");
    const [result, setResult] = useState<any>(undefined);
    const dispatch = useDispatch();

    function onParseBillClicked() {
        setError("");
        setResult(undefined);
        parseBill(value).then(response => {
            setResult(response.data);
        }).catch(error => {
            console.error(error);
            if (error.response && error.response.data) {
                setError(error.response.data.message);
            } else {
                setError("Could not parse bill: Internal server error.");
            }
        })
    }

    function onCreateCrsUpdateRecord() {
        createCrsUpdate(value).then(response => {
            dispatch({ type: UiActionType.SNACKBAR_STATE_CHANGED, newState: { open: true, message: "CRS Update record created", severity: "success" } });
        }).catch(error => {
            dispatch({ type: UiActionType.SNACKBAR_STATE_CHANGED, newState: { open: true, message: "Could not create CRS update record", severity: "error" } });
            console.error(error);
        })
    }

    return (
        <Grid container direction='column' className={`${classes.root} flex-gap-4`} alignItems="center">
            <Grid item>
                <TextField
                    multiline={true}
                    minRows={30}
                    variant='outlined'
                    value={value}
                    onChange={(event: any) => {
                        setValue(event.target.value);
                    }}
                    style={{width: '800px'}}
                >
                    
                </TextField>
            </Grid>
            <Grid item>
                <Button disabled={value.length === 0} variant='contained' color='primary' onClick={() => {
                    onParseBillClicked();
                }}>
                    Parse
                </Button>
            </Grid>
            {error &&
                <Grid item>
                    <Alert severity='error'>{error}</Alert>
                </Grid>
            }
            {result &&
                <Grid item>
                    <Alert severity='success'>Bill parsed successfully</Alert>
                </Grid>
            }
            {result &&
                <Grid item>
                    <Button variant='contained' color='primary' onClick={() => {
                        onCreateCrsUpdateRecord();
                    }}>
                        Create CRS update record
                    </Button>
                </Grid>
            }
            {result &&
                <Grid item>
                    <ReactJson src={result} />
                </Grid>
            }
        </Grid>
    )
}

export default BillParserPage;